var React = require('react');

function Page (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.30773 24C1.68029 24 1.1388 23.7722 0.683282 23.3167C0.227761 22.8612 0 22.3197 0 21.6923V2.30773C0 1.68029 0.227761 1.1388 0.683282 0.683283C1.1388 0.227762 1.68029 0 2.30773 0H28.0923C28.7197 0 29.2612 0.227762 29.7167 0.683283C30.1723 1.1388 30.4 1.68029 30.4 2.30773V21.6923C30.4 22.3197 30.1723 22.8612 29.7167 23.3167C29.2612 23.7722 28.7197 24 28.0923 24H2.30773ZM2.30773 22.1846H20.2093V15.6031H1.81537V21.6923C1.81537 21.8154 1.86665 21.9282 1.96921 22.0308C2.07179 22.1334 2.18463 22.1846 2.30773 22.1846ZM22.0246 22.1846H28.0923C28.2154 22.1846 28.3282 22.1334 28.4308 22.0308C28.5334 21.9282 28.5847 21.8154 28.5847 21.6923V7.20614H22.0246V22.1846ZM1.81537 13.7877H20.2093V7.20614H1.81537V13.7877Z","fill":"black"}));
}

Page.defaultProps = {"width":"31","height":"24","viewBox":"0 0 31 24","fill":"none"};

module.exports = Page;

Page.default = Page;
